import React, { FC } from "react";

const Menu: FC = ({ children }) => <aside className="menu">{children}</aside>;

export default Menu;
